/**
 * Product keys as defined in flight-deck.
 * https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
 */
export enum Products {
	// ATLAS_* - Need to be standalone apps to sit in this space
	ATLAS_ALIGN = 'ALIGN',
	ATLAS_HOME = 'ATLAS_HOME',
	ATLAS_GOALS = 'GOALS',
	ATLAS_TEAMS = 'TEAMS',
	ATLAS_HUB = 'ATLAS_HUB',
	ANALYTICS = 'ANALYTICS',
	ASSETS = 'ASSETS',
	BITBUCKET = 'BITBUCKET',
	COMPASS = 'COMPASS',
	CUSTOMER_SERVICE_MANAGEMENT = 'JIRA_CUSTOMER_SERVICE',
	FOCUS = 'mercury',
	STUDIO = 'STUDIO',
	OPSGENIE = 'OPSGENIE',
	JIRA_SERVICE_MANAGEMENT = 'JIRA_SERVICE_DESK',
	JIRA_PRODUCT_DISCOVERY = 'JIRA_PRODUCT_DISCOVERY',
	JIRA_SOFTWARE = 'JIRA_SOFTWARE',
	CONFLUENCE = 'CONFLUENCE',
	LOOM = 'LOOM',
	PROJECTS = 'PROJECTS',
	TALENT = 'TALENT',
	TRELLO = 'TRELLO',
}

export const ANALYTICS_CHANNEL = 'navigation';
